// extracted by mini-css-extract-plugin
module.exports = {"container":"ToggleSwitch_container__0JGYM","switch":"ToggleSwitch_switch__wEmaR","active":"ToggleSwitch_active__LcovQ","disable":"ToggleSwitch_disable___B_dT"};